import EventEmitter from "eventemitter3";
import $ from "jquery";

export class ScrollingNumbers extends EventEmitter {

  constructor(target) {
    super();

    this.$container = target;

    this.intDigits = this.$container.data("int-digits");
    this.decDigits = this.$container.data("dec-digits");
    this.digitsHeight = this.$container.find(".digit-cell").height();

    this.fadeDuration = 300;

    this.$intReels = this.$container.find(".digit-wrapper.integer .digit-reel");
    this.$decReels = this.$container.find(".digit-wrapper.decimal .digit-reel");
    this.$dot = this.$container.find(".separator.dot");
    this.$commas = this.$container.find(".separator.comma");

    this.intVisible = new Array(this.intDigits).fill(false);
    this.intHideTimers = new Array(this.intDigits).fill(null);

    this.decVisible = new Array(this.decDigits).fill(false);
    this.decHideTimers = new Array(this.decDigits).fill(null);

    this.dotVisible = false;
    this.dotHideTimer = null;

    this.forcedDecimals = null;

    this.commaAfterIndex = [];
    this.$commas.each((i, el) => {
      this.commaAfterIndex.push(Number($(el).data("after-index")));
    });
    this.commaVisible = new Array(this.$commas.length).fill(false);
    this.commaHideTimers = new Array(this.$commas.length).fill(null);

    this.init();
  }

  init() {
    this.setValue(0);
  }

  setIntDigitVisibility(i, visible, fadeDuration = this.fadeDuration) {
    const $wrapper = this.$intReels.eq(i).parent();

    // Clear any pending hide timer for this digit
    if (this.intHideTimers[i]) {
      clearTimeout(this.intHideTimers[i]);
      this.intHideTimers[i] = null;
    }

    // Make sure the width is updated when the number is already visible and still visible
    if (visible && this.intVisible[i]) {
      $wrapper.css({
        width: Math.ceil(this.$intReels.eq(i).find(".active-digit").width()) + 1,
      });
    } else if (!visible && !this.intVisible[i]) {
      $wrapper.css({
        width: 0,
      });
    }

    if (visible && !this.intVisible[i]) {
      $wrapper.css({
        width: Math.ceil(this.$intReels.eq(i).find(".active-digit").width()) + 1,
        opacity: 0
      });

      requestAnimationFrame(() => $wrapper.css({
        opacity: 1,
      }));

      this.intVisible[i] = true;

    } else if (!visible && this.intVisible[i]) {
      $wrapper.css({
        opacity: 0,
      });

      this.intHideTimers[i] = setTimeout(() => {
        $wrapper.css({
          opacity: 0,
          // overflow: "visible"
          width: 0,
        });

        this.intHideTimers[i] = null;
      }, fadeDuration);
      this.intVisible[i] = false;
    }
  }

  setDecDigitVisibility(i, visible, fadeDuration = this.fadeDuration) {
    const $wrapper = this.$decReels.eq(i).parent();

    if (this.decHideTimers[i]) {
      clearTimeout(this.decHideTimers[i]);
      this.decHideTimers[i] = null;
    }

    if (visible && this.decVisible[i]) {
      $wrapper.css({
        width: Math.ceil(this.$decReels.eq(i).find(".active-digit").width()) + 1,
      });
    } else if (!visible && !this.decVisible[i]) {
      $wrapper.css({
        width: 0,
      });
    }

    if (visible && !this.decVisible[i]) {
      $wrapper.css({
        width: Math.ceil(this.$decReels.eq(i).find(".active-digit").width()) + 1,
        opacity: 0
      });

      requestAnimationFrame(() => $wrapper.css({
        opacity: 1,
      }));

      this.decVisible[i] = true;

    } else if (!visible && this.decVisible[i]) {
      $wrapper.css({
        opacity: 0,
      });

      this.decHideTimers[i] = setTimeout(() => {
        $wrapper.css({
          opacity: 0,
          width: 0,
        });

        this.decHideTimers[i] = null;
      }, fadeDuration);
      this.decVisible[i] = false;
    }
  }

  setCommaVisibility(i, visible, fadeDuration = this.fadeDuration) {
    const $c = this.$commas.eq(i);

    if (this.commaHideTimers[i]) {
      clearTimeout(this.commaHideTimers[i]);
      this.commaHideTimers[i] = null;
    }

    if (visible && !this.commaVisible[i]) {
      $c.css({width: "auto", opacity: 0});
      requestAnimationFrame(() => $c.css({opacity: 1}));
      this.commaVisible[i] = true;

    } else if (!visible && this.commaVisible[i]) {
      $c.css({opacity: 0});
      this.commaHideTimers[i] = setTimeout(() => {
        $c.css({width: 0});
        this.commaHideTimers[i] = null;
      }, fadeDuration);
      this.commaVisible[i] = false;
    }
  }

  setDotVisibility(visible, fadeDuration = this.fadeDuration) {
    if (this.dotHideTimer) {
      clearTimeout(this.dotHideTimer);
      this.dotHideTimer = null;
    }

    if (visible && !this.dotVisible) {
      this.$dot.css({
        width: "auto",
        padding: "0 2px",
        opacity: 0
      });

      requestAnimationFrame(() => this.$dot.css({opacity: 1}));

      this.dotVisible = true;

    } else if (!visible && this.dotVisible) {
      this.$dot.css({opacity: 0});

      this.dotHideTimer = setTimeout(() => {
        this.$dot.css({width: 0, padding: 0});
        this.dotHideTimer = null;
      }, fadeDuration);

      this.dotVisible = false;
    }
  }

  setForcedDecimals(n) {
    this.forcedDecimals = n;
  }

  setDisplay(value, fadeDuration = this.fadeDuration) {
    const maxDec = Math.min(2, this.decDigits);
    const clamped = Math.max(0, value);
    const rounded = Number(clamped.toFixed(maxDec));

    const [intStr, decStr = ""] = rounded.toFixed(this.decDigits).split(".");
    const paddedInt = intStr.padStart(this.intDigits, "0");
    const paddedDec = decStr.padEnd(this.decDigits, "0");

    const firstNonZero = paddedInt.search(/[1-9]/);
    const leadingZeroCutoff = firstNonZero === -1
      ? paddedInt.length - 1  // ✅ show only the last zero for value 0
      : firstNonZero;

    paddedInt.split("").forEach((d, i) => {
      this.$intReels.eq(i).css({transform: `translateY(-${Number(d) * this.digitsHeight}px)`});
      this.$intReels.eq(i).find(".digit-cell").removeClass("active-digit");
      this.$intReels.eq(i).find(".digit-cell").eq(Number(d)).addClass("active-digit");
      this.setIntDigitVisibility(i, i >= leadingZeroCutoff, fadeDuration);
    });

    // A thousands comma is visible only if at least one digit to its left is visible.
    this.commaAfterIndex.forEach((afterIdx, i) => {
      this.setCommaVisibility(i, leadingZeroCutoff <= afterIdx, fadeDuration);
    });

    // Find the last non-zero decimal within the allowed range (max 2 decimals).
    // Trailing zeros beyond it are hidden; if all are zero, the dot is hidden too.
    let lastNonZero = -1;
    if (this.forcedDecimals != null) {
      lastNonZero = Math.min(this.forcedDecimals, maxDec) - 1;
    } else {
      for (let i = maxDec - 1; i >= 0; i--) {
        if (paddedDec[i] !== "0") {
          lastNonZero = i;
          break;
        }
      }
    }

    paddedDec.split("").forEach((d, i) => {
      this.$decReels.eq(i).css({transform: `translateY(-${Number(d) * this.digitsHeight}px)`});
      this.$decReels.eq(i).find(".digit-cell").removeClass("active-digit");
      this.$decReels.eq(i).find(".digit-cell").eq(Number(d)).addClass("active-digit");
      this.setDecDigitVisibility(i, i <= lastNonZero, fadeDuration);
    });

    this.setDotVisibility(lastNonZero >= 0, fadeDuration);
  }

  setValue(value, fadeDuration = this.fadeDuration) {
    this.setDisplay(value, fadeDuration);
  }

  reset() {

  }
}
